// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1zNvX","buttons":"RemoveExpirationActionButtons_buttons__36xVY"};